module.exports = __webpack_public_path__ + "static/006692-b720fe615f4bea536c7382c051d364b2.jpg";